import script from "./applySuccess.vue?vue&type=script&lang=ts&setup=true"
export * from "./applySuccess.vue?vue&type=script&lang=ts&setup=true"

import "./applySuccess.vue?vue&type=style&index=0&id=b2dcea96&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2dcea96"]])

export default __exports__